import {
    MapOptions
} from "esdm-map/dist";
import { YorkBaseLayerTypes } from "./YorkBaseLayerFactory_27700";


export class DefaultMapOptions {

    public static GetDefaultOptions(
        mapElementId: string,
        mapStoreKey: string
    ): MapOptions {       

        let opt = new MapOptions();       
        opt.bingApiKey = $(`#${mapElementId}`).data("bing-api-key");
        opt.esdmOsmApiKey = $(`#${mapElementId}`).data("esdm-osm-api-key");
        opt.baseMaps = [YorkBaseLayerTypes.YorkOS, YorkBaseLayerTypes.OS_1852_Historic, YorkBaseLayerTypes.YorkAerials,YorkBaseLayerTypes.Lidar];
        opt.defaultBaseMap = YorkBaseLayerTypes.YorkOS;
        opt.enableBoundsTracking = true;
        opt.zoomToNearestBounds = false;
        opt.maxZoomToBounds = 19;
        opt.mapElementId = mapElementId;
        opt.mapStoreKey = mapStoreKey;
        opt.mapZoom = 15;
        opt.minZoom = 12;
        opt.maxZoom = 20;
                
        opt.extent = [352562, 343355, 570020, 558919];
        opt.mapCentre = [460218, 452158];

        opt.displayProjection = "EPSG:27700";
        opt.dataProjection = "EPSG:27700";
        opt.dragRotateAndZoom = false;        
        opt.zoomToNearestBounds = false;
        return opt;
    }

}